import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import UserMenu from "../components/auth/UserMenu";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    logo: {
      height: "3rem",
      marginRight: "3rem",
    },
    appBar: {
      backgroundColor: "black",
    },
    navLink: {
      flexGrow: 1,
      color: "#FFF",
      textDecoration: "none",
      "&:hover": {
        textDecoration: "underline",
      },
    },
  })
);

function AppHeader() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.appBar}>
        <Toolbar>
          <UserMenu/>
        </Toolbar>
      </AppBar>
    </div>
  );
}

export default AppHeader;
